// import liraries
import React, { Component } from 'react';
import Context from './context';

// create a component
export default class ProviderContext extends Component {
  

  state = {
    inspector: {},
    customer: {},
    editInspector: item => {
      this._addInspector(item);
    },
    editCustomer: item => {
      this._addCustomer(item);
    },
    currentInspection: {},
    editCurrentInspection(item) {
      this.currentInspection = item;
    },
  };

  _addInspector = item => {
    this.setState({
      inspector: item,
    });
  };

  _addCustomer = item => {
    this.setState({
      customer: item,
    });
  };

  render() {
    const { children } = this.props;
    return <Context.Provider value={this.state}>{children}</Context.Provider>;
  }
}

export const { Consumer } = Context;



// WEBPACK FOOTER //
// ./src/data/contextData.js